<template>
    <sosh-mobile-recovery
        v-if="isSoshShop"
        :recovery-amount-in-cents="recoveryAmountInCents"
        :recovery-device-model="recoveryDeviceModel"
        :manual-estimation="manualEstimation"
        :bonus-amount-in-cents="bonusAmountInCents"
        :simulator-modal-id="simulatorModalId"
        :recovery-modal-id="recoveryModalId"
        :bonus-recovery-selector-link="bonusRecoverySelectorLink"
        :bonus-recovery-selector-link-label="bonusRecoverySelectorLinkLabel"
        :messages="messages"
        :desktop-visual="visual.soshDesktopSrc"
        :mobile-visual="visual.soshMobileSrc"
    />
    <orange-mobile-recovery
        v-else
        :recovery-amount-in-cents="recoveryAmountInCents"
        :recovery-device-model="recoveryDeviceModel"
        :manual-estimation="manualEstimation"
        :bonus-amount-in-cents="bonusAmountInCents"
        :simulator-modal-id="simulatorModalId"
        :recovery-modal-id="recoveryModalId"
        :bonus-recovery-selector-link="bonusRecoverySelectorLink"
        :bonus-recovery-selector-link-label="bonusRecoverySelectorLinkLabel"
        :messages="messages"
        :device-visual="visual.orangeDeviceSrc"
        :wallpaper-desktop-visual="visual.orangeDesktopWallpaperSrc"
        :wallpaper-mobile-visual="visual.orangeMobileWallpaperSrc"
    />
</template>

<script>

import OrangeMobileRecovery from './OrangeMobileRecovery.vue';
import SoshMobileRecovery from './SoshMobileRecovery.vue';

export default {
    name: "MobileRecovery",
    components: {
        OrangeMobileRecovery,
        SoshMobileRecovery
    },
    props: {
        recoveryAmountInCents: {
            type: Number,
            default: null
        },
        recoveryDeviceModel: {
            type: String,
            default: null
        },
        manualEstimation: {
            type: Boolean,
            default: null
        },
        bonusAmountInCents: {
            type: Number,
            default: null
        },
        simulatorModalId: {
            type: String,
            required: true
        },
        recoveryModalId: {
            type: String,
            default: undefined
        },
        bonusRecoverySelectorLink: {
            type: String,
            default: null
        },
        bonusRecoverySelectorLinkLabel: {
            type: String,
            default: null
        },
        messages: {
            type: Object,
            required: true
        },
        visual: {
            type: Object,
            required: true
        },
        shop: {
            type: String,
            required: true
        }
    },
    computed: {
        isSoshShop() {
            return this.shop === 'SOSH'
        }
    }
}
</script>
